import * as React from 'react';
import { css } from 'aphrodite';

import * as autoForm from 'login-utils/autoForm';
import * as autoLoanUtils from 'login-utils/autoLoanUtils';
import AutoUsedPurchaseSVG from 'login-components/Common/svg/AutoUsedPurchaseSVG';
import AutoNewPurchaseSVG from 'login-components/Common/svg/AutoNewPurchaseSVG';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import LargeIconButtonGroup from 'login-components/Common/LargeIconButtonGroup/LargeIconButtonGroup';
import { LargeIconButtonConfig } from 'login-components/Common/Buttons/LargeIconButton';
import LoadingSpinner from 'login-components/Common/LoadingSpinner/LoadingSpinner';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';
import States from 'login-constants/states';

const autoVehicleConditionConfigs: LargeIconButtonConfig[] = [
  {
    value: 'NEW',
    iconComponent: AutoNewPurchaseSVG,
    buttonId: 'it-chooseAutoPurchaseTypeNew',
    text: 'New',
    subText: '',
  },
  {
    value: 'USED',
    iconComponent: AutoUsedPurchaseSVG,
    buttonId: 'it-chooseAutoPurchaseTypeUsed',
    text: 'Used',
    subText: '',
  },
];

// if the user lands on this page and somehow hasn't set fields,
// we can assume a PURCHASE and can clear autoRefinanceType
const initialValues: DataShape = {
  autoLoanPurposeType: 'PURCHASE',
  autoRefinanceType: null,
  autoVehicleCondition: null,
};

export type ChooseAutoPurchaseTypeProps = ReactRouter.RouteComponentProps<{}, {}>;

interface ChooseAutoLoanPurchaseTypeState {
  isSubmitting: boolean;
  error: string;
}

export class ChooseAutoPurchaseType extends React.Component<
  ChooseAutoPurchaseTypeProps & FormProps<DataShape, ChooseAutoPurchaseTypeProps, ReduxState>,
  ChooseAutoLoanPurchaseTypeState
> {
  state = {
    isSubmitting: false,
    error: '',
  };

  onSelect = async value => {
    if (autoLoanUtils.shouldCreateOrUpdateAutoLoan()) {
      this.setState({
        error: '',
        isSubmitting: true,
      });
      try {
        await autoLoanUtils.createOrUpdateAutoLoan({
          autoLoanPurposeType: 'PURCHASE',
          autoVehicleCondition: value,
        });
      } catch (err) {
        this.setState({
          error: 'Failed to create application, please try again',
          // Only unset on error, since we navigate away in the success case
          // and don't want the user to be able to submit again
          isSubmitting: false,
        });
      }
    } else {
      hashHistory.push(States.CREATE_ACCOUNT);
    }
  };

  render() {
    const { error, isSubmitting } = this.state;
    return (
      <div>
        {isSubmitting ? (
          <div className={css(paneFormStyles.loadingSpinnerWrapper)}>
            <LoadingSpinner />
          </div>
        ) : (
          <React.Fragment>
            {error && (
              <div className={css(paneFormStyles.errorWrapper)}>
                <ErrorMessage errorText={error} />
              </div>
            )}
            <Field
              name={autoForm.FIELDS.autoVehicleCondition}
              configs={autoVehicleConditionConfigs}
              onSelect={this.onSelect}
              component={LargeIconButtonGroup}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

const withReduxForm = reduxForm<
  FormProps<DataShape, ChooseAutoPurchaseTypeProps, ReduxState>,
  ChooseAutoPurchaseTypeProps,
  ReduxState
>({
  initialValues,
  ...autoForm.FORM_CONFIG,
})(ChooseAutoPurchaseType);

export default connect<{}, {}, ChooseAutoPurchaseTypeProps>(null, {})(withReduxForm);
